// Copyright (c) 2026 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import { responseMetadataSchema } from '@/api/types';
import { chargeSchema } from '@/billing/api/types';
import { z } from 'zod';

const revertChargeCancellationResponseSchema = z
  .object({
    data: chargeSchema,
    metadata: responseMetadataSchema,
  })
  .transform(({ data, ...response }) => ({ ...response, charge: data }));

type RevertChargeCancellationResponse = z.infer<
  typeof revertChargeCancellationResponseSchema
>;

export async function revertChargeCancellation(
  chargeKey: string
): Promise<RevertChargeCancellationResponse> {
  const url = `/v1/charge/${chargeKey}/revert-cancellation`;
  const response = await api.post(url);

  return parseResponse(revertChargeCancellationResponseSchema, response.data, {
    schemaName: 'RevertChargeCancellation',
    endpoint: url,
  });
}
